import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IDefaultLayer,
  IFoundInfo,
  ISelectedATE,
  ISelectLayer,
  ISelectLayersATE,
  LayersReducer,
} from 'types/mainPage';

const initialATE = {
  name: '',
  type: '',
  label: '',
  id: 0,
  dataset_name: '',
  soato: '',
};

const initialState: LayersReducer = {
  allLayers: [],
  allChildren: [],
  selectLayers: [],
  ateCities: [],
  ateRegions: [],
  ateVC: [],
  selectedATE: initialATE,
  currAteRegion: initialATE,
  currAteCity: initialATE,
  currAteVC: initialATE,
  currentLayer: '',
  currentLayerId: 0,
  currentUrl: '',
  currenLegendtUrl: '',
  currenMapFileUrl: '',
  currentLayerParent: undefined,
  currentLayerTitle: '',
  legendSize: '',
  defaultLayer: 0,
  wktATE: '',
  loading: false,
  foundWkt: '',
  foundInfo: '',
  foundInfoCoords: [],
  foundInfoSoato: '',
  currentYear: '',
  years: [],
  searchByClickZlevel: 0,
  needUpdateFoundInfo: false,
  searchWkt: false,
  currentLayer_scale_1_50: 0,
  layer_scale_1_50_vector: 0,
  currenMetaFileUrl: '',
};

export const layersSlice = createSlice({
  initialState,
  name: 'layers',
  reducers: {
    setAllLayers(state, action: PayloadAction<IDefaultLayer[]>) {
      state.allLayers = action.payload;
    },
    setAllChildren(state, action: PayloadAction<ISelectLayer[]>) {
      state.allChildren = action.payload;
    },
    setSelectLayers(state, action: PayloadAction<ISelectLayersATE[]>) {
      state.selectLayers = action.payload;
    },
    setSelectedATE(state, action: PayloadAction<ISelectedATE | null>) {
      state.selectedATE = action.payload;
    },
    setAte(
      state,
      action: PayloadAction<{ param: string; ate: ISelectLayersATE[] }>
    ) {
      state[action.payload.param] = action.payload.ate;
    },
    setCurrentAte(
      state,
      action: PayloadAction<{ param: string; ate: ISelectedATE | null }>
    ) {
      state[action.payload.param] = action.payload.ate;
    },
    resetSelectedATE(state) {
      state.selectedATE = initialATE;
      state.wktATE = '';
      state.searchWkt = false;
    },
    setWKT(state, action: PayloadAction<string>) {
      state.wktATE = action.payload;
    },
    resetWKT(state) {
      state.wktATE = '';
    },
    setCurrentLayer(
      state,
      action: PayloadAction<{
        layer: string;
        layerId: number;
        url: string;
        legendUrl: string;
        currenMapFileUrl: string;
        metaFile: string;
        parent?: string;
        layerTitle?: string;
        legendSize?: string;
        currentLayer_scale_1_50?: number;
        layer_scale_1_50_vector?: number;
      }>
    ) {
      state.currentLayer = action.payload.layer;
      state.currentUrl = action.payload.url;
      state.currentLayerId = action.payload.layerId;
      state.currenLegendtUrl = action.payload.legendUrl;
      state.currenMapFileUrl = action.payload.currenMapFileUrl;
      state.currenMetaFileUrl = action.payload.metaFile;
      state.currentLayerParent = action.payload.parent;
      state.currentLayerTitle = action.payload.layerTitle;
      state.legendSize = action.payload.legendSize;
      state.currentLayer_scale_1_50 = action.payload.currentLayer_scale_1_50;
      state.layer_scale_1_50_vector = action.payload.layer_scale_1_50_vector;
    },
    setDefaultLayer(state, action: PayloadAction<number>) {
      state.defaultLayer = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setCurrentYear(state, action: PayloadAction<string>) {
      state.currentYear = action.payload;
    },
    setYears(state, action: PayloadAction<number[]>) {
      state.years = action.payload;
    },
    setInfo(
      state,
      action: PayloadAction<{
        wkt: string;
        info: string;
        coords: number[];
        soato: string;
        zLevel: number;
      }>
    ) {
      state.foundWkt = action.payload.wkt;
      state.foundInfo = action.payload.info;
      state.foundInfoCoords = action.payload.coords;
      state.foundInfoSoato = action.payload.soato;
      state.searchByClickZlevel = action.payload.zLevel;
    },
    setNeedUpdateInfo(state, action: PayloadAction<boolean>) {
      state.needUpdateFoundInfo = action.payload;
    },
    setSearchWkt(state, action: PayloadAction<boolean>) {
      state.searchWkt = action.payload;
    },
    resetInfo(state) {
      state.foundWkt = '';
      state.foundInfo = '';
      state.foundInfoCoords = [];
      state.searchByClickZlevel = 0;
    },
    resetAte(state, action: PayloadAction<{ param: string; value: string }>) {
      state[action.payload.param] = [];
      state[action.payload.value] = initialATE;
      state.wktATE = '';
    },
    resetLayers() {
      return initialState;
    },
  },
});

export default layersSlice.reducer;
